import { instantsInterceptor, } from '@/api/index';
import { setInterceptors } from '@/api/common/interceptor';
import axios from 'axios';



function getLanguages() {
    return instantsInterceptor.get('/service/code/languages');
}

function getProdList(lang, level, upperId) {
    return instantsInterceptor.get('/mgmt/prodType/prodList?lang=' + lang + '&level=' + level + '&upperId=' + upperId);
}

function fetchProdtypeForm(upperId, level) {
    return instantsInterceptor.get('/mgmt/prodType/form?upperId=' + upperId + '&level=' + level);
}

function addProdType(form) {
    return instantsInterceptor.post('/mgmt/prodType/form', form);
}

function getProdTypeAndLabel(doctypeId) {
    return instantsInterceptor.get('/mgmt/prodType/updateForm/' + doctypeId);
}

function update(form) {
    return instantsInterceptor.post('/mgmt/prodType/update', form);
}

function updateProdTypeOrder(form) {
    return instantsInterceptor.post('/mgmt/prodType/changeOrder', form);
}

function changeProdUse(form) {
    return instantsInterceptor.post('/mgmt/prodType/changeUse', form);
}

function deleteProd(form) {
    return instantsInterceptor.post('/mgmt/prodType/delete', form);
}

function downExcel() {
    let axiosInstance = axios.create({
        baseURL: process.env.VUE_APP_API_URL,
        headers: {
            'Access-Control-Allow-Origin': '*',
        },
        responseType: 'blob',
    });

    let instance = setInterceptors(axiosInstance);

    return instance.get('/mgmt/prodType/excel');
}

function getFirstProdTypeList() {
    return instantsInterceptor.get('/mgmt/statistics/prodType/getFirstProdTypeList');
}

function getSecondProdTypeList(firstProdType) {
    return instantsInterceptor.get('/mgmt/statistics/prodType/getSecondProdTypeList?firstProdType=' + firstProdType);
}

function getChartData(year, firstProdType, secondProdType) {
    return instantsInterceptor.get('/mgmt/statistics/prodType/result?' + "year=" + year + "&firstProdType=" + firstProdType + "&secondProdType=" + secondProdType);
}

function checkProdTypeNameDuplication(form) {
    return instantsInterceptor.post('/mgmt/prodType/check', form);
}


export { getLanguages, getProdList, fetchProdtypeForm, addProdType, getProdTypeAndLabel, update, updateProdTypeOrder, changeProdUse, deleteProd, downExcel, getFirstProdTypeList, getSecondProdTypeList, getChartData, checkProdTypeNameDuplication };